module.exports = __webpack_public_path__ + "img/OK.e12f0d55.png";